// Dashboard.tsx
import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Statistic,
    Select,
    DatePicker,
    Button,
    Divider,
} from "antd";
import { Get_dashboard } from "../../../Services/Requests";
import Loader from "Components/loader/loader";
import { showWarningAlert, showErrorAlert } from "Util/Alerts";
import {
    DollarCircleOutlined,
    ShoppingCartOutlined,
    UserOutlined,
    AppstoreOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import styles from "./dashboard.module.css";
import { ca } from "date-fns/locale";

const { Option } = Select;
const { RangePicker } = DatePicker;

const Dashboard = () => {
    const [filter, setFilter] = useState<string>("today");
    const [loading, setLoading] = useState<boolean>(true);
    const [categories, setCateogries] = useState({
        total_orders: 0,
        total_registered_users: 0,
        total_products_listed: 0,
        total_sales: 0,
        categorySales: [],
        ordersBystatus: {
            completed_orders: 0,
            pending_orders: 0,
            processing_orders: 0,
            totalOrders: 0,
        },
    });
    const [customRange, setCustomRange] = useState<any>([null, null]);
    const [categorySales, setCategorySales] = useState([
        { category: "Electronics", amount: 24500 },
        { category: "Fashion", amount: 18300 },
        { category: "Home & Kitchen", amount: 12900 },
    ]);

    const handleFilterChange = (value: string) => {
        setFilter(value);
        if (value != "custom") {
            getDashbaord(value);
        }
    };

    const handleDateChange = (dates: any) => {
        setCustomRange(dates);
    };

    const getDashbaord = async (filter: string) => {
        setLoading(true);
        let body: any = { type: filter };

        if (filter == "custom") {
            if (customRange[0] && customRange[1]) {
                body = {
                    type: "custom",
                    fromDate: dayjs(customRange[0]).format("YYYY-MM-DD"),
                    toDate: dayjs(customRange[1]).format("YYYY-MM-DD"),
                };
            } else {
                showErrorAlert("Invalid date range selected");
                return;
            }
        }

        try {
            const response = await Get_dashboard(body);
            console.log(response);
            if (response?.data?.status === 1) {
                setCateogries({
                    total_sales: response?.data?.total_sales,
                    categorySales: response?.data?.categorySales,
                    total_orders: response?.data?.total_orders,
                    total_registered_users:
                        response?.data?.total_registered_users,
                    total_products_listed:
                        response?.data?.total_products_listed,
                    ordersBystatus: response?.data?.ordersBystatus,
                });
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getDashbaord("today");
    }, []);
    return (
        <div className={styles.dashboard}>
            <div className={styles.header}>
                <h2>Dashboard</h2>
                <div className={styles.filter}>
                    <Select
                        value={filter}
                        onChange={handleFilterChange}
                        style={{ width: 150 }}>
                        <Option value="today">Today</Option>
                        <Option value="this_week">This Week</Option>
                        <Option value="this_month">This Month</Option>
                        <Option value="this_year">This Year</Option>
                        <Option value="custom">Custom</Option>
                    </Select>
                    {filter === "custom" && (
                        <>
                            <RangePicker
                                value={customRange}
                                onChange={handleDateChange}
                                style={{ marginLeft: 8 }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 8 }}
                                onClick={() => getDashbaord("custom")}>
                                Submit
                            </Button>
                        </>
                    )}
                </div>
            </div>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card
                                className={styles.card}
                                style={{
                                    background:
                                        "linear-gradient(135deg, #e0f7fa, #b2ebf2)",
                                }}>
                                <Statistic
                                    title="Total Sales"
                                    value={categories.total_sales}
                                    prefix={
                                        <DollarCircleOutlined
                                            style={{ color: "#00695c" }}
                                        />
                                    }
                                    valueStyle={{ color: "#004d40" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card
                                className={styles.card}
                                style={{
                                    background:
                                        "linear-gradient(135deg, #f1f8e9, #dcedc8)",
                                }}>
                                <Statistic
                                    title="Total Orders"
                                    value={
                                        categories.ordersBystatus.totalOrders
                                    }
                                    prefix={
                                        <ShoppingCartOutlined
                                            style={{ color: "#558b2f" }}
                                        />
                                    }
                                    valueStyle={{ color: "#33691e" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card
                                className={styles.card}
                                style={{
                                    background:
                                        "linear-gradient(135deg, #fff3e0, #ffe0b2)",
                                }}>
                                <Statistic
                                    title="Total Registered Users"
                                    value={categories.total_registered_users}
                                    prefix={
                                        <UserOutlined
                                            style={{ color: "#ef6c00" }}
                                        />
                                    }
                                    valueStyle={{ color: "#e65100" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card
                                className={styles.card}
                                style={{
                                    background:
                                        "linear-gradient(135deg, #ede7f6, #d1c4e9)",
                                }}>
                                <Statistic
                                    title="Total Products"
                                    value={categories.total_products_listed}
                                    prefix={
                                        <AppstoreOutlined
                                            style={{ color: "#5e35b1" }}
                                        />
                                    }
                                    valueStyle={{ color: "#4527a0" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card className={styles.card}>
                                <Statistic
                                    title="Pending Orders"
                                    value={
                                        categories.ordersBystatus.pending_orders
                                    }
                                    prefix={
                                        <ClockCircleOutlined
                                            style={{ color: "#ff9800" }}
                                        />
                                    }
                                    valueStyle={{ color: "#ef6c00" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card className={styles.card}>
                                <Statistic
                                    title="Processing Orders"
                                    value={
                                        categories.ordersBystatus
                                            .processing_orders
                                    }
                                    prefix={
                                        <SyncOutlined
                                            style={{ color: "#03a9f4" }}
                                        />
                                    }
                                    valueStyle={{ color: "#0288d1" }}
                                />
                            </Card>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card className={styles.card}>
                                <Statistic
                                    title="Completed Orders"
                                    value={
                                        categories.ordersBystatus
                                            .completed_orders
                                    }
                                    prefix={
                                        <CheckCircleOutlined
                                            style={{ color: "#4caf50" }}
                                        />
                                    }
                                    valueStyle={{ color: "#2e7d32" }}
                                />
                            </Card>
                        </Col>
                        {/* 
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card className={styles.card}>
                                <Statistic
                                    title="Cancelled / Returned"
                                    value={
                                        categories.ordersBystatus
                                            .cancelled_returned_orders
                                    }
                                    prefix={
                                        <CloseCircleOutlined
                                            style={{ color: "#f44336" }}
                                        />
                                    }
                                    valueStyle={{ color: "#c62828" }}
                                />
                            </Card>
                        </Col> */}
                    </Row>
                    {categories.categorySales.length > 0 && (
                        <Divider orientation="left" style={{ marginTop: 32 }}>
                            Category-wise Sales
                        </Divider>
                    )}
                    {categories.categorySales.length > 0 && (
                        <Row gutter={[16, 16]}>
                            {categories.categorySales.map(
                                (item: any, index) => (
                                    <Col
                                        xs={24}
                                        sm={12}
                                        md={8}
                                        lg={6}
                                        key={index}>
                                        <Card className={styles.card}>
                                            <Statistic
                                                title={item.category_name}
                                                value={item.total_sales}
                                                prefix={
                                                    <DollarCircleOutlined />
                                                }
                                            />
                                        </Card>
                                    </Col>
                                )
                            )}
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default Dashboard;
